import enTranslationSurveyStatus from "./en/translation-survey-status.json";
import enTranslationSurveyRespondentErrors from "./en/translation-survey-respondent-errors.json";
import enTranslationSurveys from "./en/translation-surveys.json";
import enTranslationSurveyDashboard from "./en/translation-survey-dashboard.json";
import enTranslationWelcomePage from "./en/translation-welcome-page.json";
import enTranslationEmailCycles from "./en/translation-email-cycles.json";
import enTranslationManageUsers from "./en/translation-manage-users.json";
import enTranslationCommon from "./en/translation-common.json";
import enTranslationExternalPublicApis from "./en/translation-external-public-apis.json";
import enTranslationErrors from "./en/translation-errors.json";
import enTranslationEmailTemplates from "./en/translation-email-templates.json";
import enTranslationSurveyLinkStatus from "./en/translation-survey-link-status.json";
import enTranslationProjects from "./en/translation-projects.json";
import enTranslationFilters from "./en/translation-filters.json";

export const eagleEnTranslation = {
  surveyStatus: enTranslationSurveyStatus,
  surveyRespondentErrors: enTranslationSurveyRespondentErrors,
  surveys: enTranslationSurveys,
  surveyDashboard: enTranslationSurveyDashboard,
  welcomePage: enTranslationWelcomePage,
  emailCycles: enTranslationEmailCycles,
  manageUsers: enTranslationManageUsers,
  common: enTranslationCommon,
  externalPublicApis: enTranslationExternalPublicApis,
  errors: enTranslationErrors,
  emailTemplates: enTranslationEmailTemplates,
  surveyLinkStatus: enTranslationSurveyLinkStatus,
  projects: enTranslationProjects,
  filters: enTranslationFilters,
};
